import React from 'react'
import { I18n } from 'react-redux-i18n';
import EntityGeneralForm from '../../../baseApp/entities/components/fields/EntityGeneralForm';
import BuildingSubForm from '../../otherEntities/components/BuildingSubForm';
import FormButtons from "../../../baseApp/shared/components/others/formButtons/FormButtons";
import Alert from "../../../baseApp/shared/components/alerts/Alert";
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';

const BuildingsForm = ({
    buildingFormData: {
        name,
        parent,
        subFormData = {}
    },
    alert,
    editMode,
    createMode,
    viewMode,
    entityList,
    handleFieldChange,
    handleSubFormFieldChange,
    handleOnFieldBlur,
    handleSubmitClick,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
}) => {
    return <div className="form-container">
        <div className="form">
            <Alert
                {...alert}
            />
            <div className="header">
                {buildHeader(createMode, editMode, viewMode)}
            </div>
            <div className="fields">
                <EntityGeneralForm
                    name={name}
                    parent={parent}
                    entityList={entityList}
                    handleOnFieldBlur={handleOnFieldBlur}
                    handleFieldChange={handleFieldChange}
                    createMode={createMode}
                    viewMode={viewMode}
                    editMode={editMode}
                />
                <BuildingSubForm
                    {...subFormData}
                    handleFieldChange={handleSubFormFieldChange}
                    viewMode={viewMode}
                />
            </div>
            {(createMode || editMode) &&
                <div className="buttons">
                    <button
                        className=" mt-3 btn btn-primary"
                        onClick={handleSubmitClick}
                    >
                        {I18n.t("forms.save")}
                    </button>
                </div>
            }
        </div>
        <div className="form-options">
            <FormButtons
                editMode={editMode}
                viewMode={viewMode}
                handleBackClick={handleBackClick}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                appModule={appModules.ENTITY}
            />
        </div>
    </div>
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("buildings.form.headers.create") :
        editMode ?
            I18n.t("buildings.form.headers.edit") :
            I18n.t("buildings.form.headers.view");
}

export default BuildingsForm;